resourcePaths = '{"rootPath":"","assetsPath":""}';/* Accessible Container is a accessibiliy component that traps the user tab key into a specific
container. The only way the user returns to the normal tabbing cycle is by pressing ESC key
which then will return the user to the previously focused element, it also looks for the
js--aria-hidden-navigation class to trigger the aria hidden attribute

USAGE:
1. Extend _AccessibleContainer to your component this.extends = [_AccessibleContainer]
2. Add this._previouslyFocusedElement(); to your init so it can detect your tabs and store them
3. if your component is created through javascript then add `this._trapTab();` when it's
displayed or you can also add it in init
4. Make sure you add js--tab-trapper to the container where you want to trap the user's tab
5. Make sure to call this._accessibilityVisibility() properly to trigger the aria hidden elements
use true for when the dialog or your component has the focus, and false for when you're outside
the component
6. You're all set the Component will keep listening for everything inside js--tab-trapper so if
you add dynamicly itens inside that container they will also work
*/

function _AccessibleContainer () {
  this.documentElement = $(document);
  this.isFirstElementFocused = false;
  this.isLastElementFocused = false;
  this.previousFocusedElement = null;
  this.focusableElementsString =
    'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
    'textarea:not([disabled]), button:not([disabled]), iframe, object, embed, ' +
    '*[tabindex], *[contenteditable]';

  this.$ariaHidden = $('.js--aria-hidden-navigation');

  this.init = function () {};

  this.initAllReady = function () {};

  this._previouslyFocusedElement = function () {
    var _this = this;

    this.documentElement.keyup(function (e) {
      var checkTrigger = $('body').hasClass('js--accessible-container-displayed');

      if (e.which === 9) {
        if (checkTrigger === false) {
          this.previousFocusedElement = $(document.activeElement);
        }
      }

      if (e.which === 27) {
        if (this.previousFocusedElement !== undefined) {
          this.previousFocusedElement.focus();
        }
      }
    });
  };

  this._trapTab = function () {
    var _this = this;
    this.documentElement.keydown(function (e) {
      var tabTrapperContainer = $(_this.node).find('.js--tab-trapper');
      var focusableItems = tabTrapperContainer
        .find(_this.focusableElementsString)
        .filter(':visible');
      var firstFocusableElement = focusableItems.first();
      var lastFocusableElement = focusableItems.last();

      if (e.which === 9) {
        if (firstFocusableElement.is(':focus')) {
          this.isFirstElementFocused = true;
        } else {
          this.isFirstElementFocused = false;
        }

        if (lastFocusableElement.is(':focus')) {
          this.isLastElementFocused = true;
        } else {
          this.isLastElementFocused = false;
        }

        if (this.isLastElementFocused === true && e.shiftKey === false) {
          e.preventDefault();
          firstFocusableElement.focus();
          this.isLastElementFocused = false;
        }

        if (this.isFirstElementFocused === true && e.shiftKey) {
          e.preventDefault();
          lastFocusableElement.focus();
          this.isFirstElementFocused = false;
        }
      }
    });
  };

  this._accessibilityVisibility = function (visibility) {
    if (visibility === true) {
      this.$ariaHidden.attr('aria-hidden', 'true');
    } else {
      this.$ariaHidden.attr('aria-hidden', 'false');
    }
  };
}
